<template>
  <div class="credits">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>Interventions</h1>
          <br>
          <RunButtons :key="'runbuttons_' + currentRun.getCurrentStep()" />
        </div>
        <div class="col-sm-3">
          <CovidStatus :key="'covidstatus_' + currentRun.getCurrentStep()" />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="container">
      <section class="widget policies-container">
        <form class="form-inline">
          <div class="row inputs-container">
            <div class="table-row">
              <div class="col-xs-6 no-float" />
              <div class="col-xs-3 text-center top no-float">
                <h4>Previous step</h4>
                <div class="history">
                  <router-link to="/interventions-history">
                    History
                  </router-link>
                </div>
              </div>
              <div
                class="col-xs-3 white-background text-center top no-float currentRun"
              >
                <h4>Next step</h4>
                <p>
                  Use these tick boxes to turn on actions to improve conditions.
                  Any changes you already made will appear here.
                </p>
              </div>
              <div class="clearfix" />
            </div>
          </div>

          <template v-for="cat in inputCategories">
            <div
              :key="cat.reference"
              class="row inputs-container"
            >
              <div class="table-row white-background">
                <div class="form-group col-xs-6 text-left no-float">
                  <h3>{{ cat.name }}</h3>
                </div>

                <div
                  class="form-group
                  col-xs-3
                  no-float
                  text-center"
                />
                <div
                  class="form-group
                  col-xs-3
                  no-float
                  text-center
                  currentRun"
                />

                <div class="clearfix" />
              </div>
            </div>

            <template
              v-for="(input, index) in inputsForCategory(cat.reference)"
            >
              <div
                :key="input.label"
                :class="
                  'row inputs-container white-background ' +
                    (index % 2 === 1 ? '' : 'striped')
                "
              >
                <div class="table-row">
                  <div class="form-group col-xs-6 text-left no-float">
                    <label
                      for="exampleInputName2"
                      class="control-label"
                    >
                      {{ input.label }}
                      <span
                        class="info-badge badge"
                        data-toggle="popover"
                        data-trigger="hover"
                        data-container="body"
                        data-placement="right"
                        :data-title="null"
                        :data-content="input.description"
                      >i</span>
                    </label>
                    <p class="muted">
                      <small>
                        <template
                          v-if="input.oneoff"
                        >- this policy can only be implemented once.</template>
                      </small>
                    </p>
                  </div>

                  <div
                    class="form-group
                    col-xs-3
                      no-float
                    text-center"
                  >
                    <input
                      type="checkbox"
                      :checked="
                        input.values[`time${currentRun.getCurrentStep() - 1}`]
                      "
                      disabled="true"
                      @click="changeInputValue(input)"
                    >
                  </div>
                  <div
                    class="form-group
                    col-xs-3
                      no-float
                    text-center currentRun"
                  >
                    <template v-if="!input.oneoff">
                      <input
                        type="checkbox"
                        :checked="
                          input.values[`time${currentRun.getCurrentStep()}`]
                        "
                        :disabled="
                          input.oneoff ||
                            currentRun.getCurrentStep() == maxNumberOfRuns
                        "
                        @click="changeInputValue(input)"
                      >
                    </template>
                  </div>

                  <div class="clearfix" />
                </div>
              </div>
            </template>
          </template>

          <div class="row inputs-container">
            <div class="table-row">
              <div class="col-xs-6 no-float" />
              <div class="col-xs-3 text-center bottom no-float" />
              <div
                class="col-xs-3 white-background text-center bottom no-float currentRun"
              />
              <div class="clearfix" />
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import CovidStatus from "../components/CovidStatus";
import RunButtons from "../components/RunButtons.vue";

import data from "../services/data";
import * as $ from "jquery";
import "bootstrap";

export default {
  components: {
    CovidStatus,
    RunButtons
  },
  data() {
    return {
      inputs: [],
      inputCategories: data.inputCategories,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      runStages: data.runStages,
      maxNumberOfRuns: data.maxNumberOfRuns
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    $(document).ready(function() {
      $(".info-badge").each(function() {
        $(this).popover();
      });
    });
    this.setupInputVariables();
  },
  methods: {
    // If this is the first run and the input variables are not
    // loaded yet, let's copy the default values from the data
    // const.
    setupInputVariables() {
      var inputVariables = this.currentRun.getInputVariables();
      if (!inputVariables || inputVariables.length === 0) {
        inputVariables = [];

        for (var d of data.inputs) {
          const values = {};
          for (var i = 1; i <= this.maxNumberOfRuns; i++) {
            values[`time${i}`] = false;
          }

          const input = {
            label: d.label,
            description: d.description,
            reference: d.reference,
            oneoff: d.oneoff,
            values,
            modelVariable: d.modelVariable,
            category: d.category
          };

          inputVariables.push(input);
        }

        this.currentRun.setInputVariables(inputVariables);
      }
      this.inputs = this.currentRun.getInputVariables();
    },
    changeInputValue(variable) {
      const runIndex = this.currentRun.getCurrentStep();
      const checked = !variable.values[`time${runIndex}`];
      variable.values[`time${runIndex}`] = checked;

      //
      // When one of the input variables change for this year, we have
      // to copy this variable for each further iteration as well.
      // This to keep what happens in the model aligned with the user
      // experience.
      //
      for (var i = runIndex; i <= this.maxNumberOfRuns; i++) {
        variable.values[`time${i}`] = checked;
      }
    },
    /**
     * For display only: we display inputs grouped by their category.
     * This is a helper function to return all inputs that belong to
     * a specific group.
     */
    inputsForCategory(categoryName) {
      if (!categoryName) {
        return this.inputs;
      }
      return this.inputs.filter(e => e.category === categoryName);
    }
  }
};
</script>

<style lang="scss">
.headtext {
  margin: -22px 0 30px 0;
  padding: 15px 0;
  background: #efefef;
}
.currentRun {
  border-width: 0 2px;
  border-style: solid;
  border-color: #009482;
}
.top.currentRun {
  border-width: 2px 2px 0 2px;
}
.top .history {
  font-weight: bold;
  font-size: 0.8em;
  padding-bottom: 10px;
  margin-top: -12px;
}
.top h4 {
  padding-bottom: 8px;
}
.top p {
  font-size: 0.95em;
}
.top {
  padding-top: 25px;
  padding-bottom: 18px;
  font-weight: 400;
  font-size: 14px;
}
.widget.policies-container {
  background: none;
}
.widget.policies-container .white-background,
.widget.policies-container .white-background-ifcurrent.currentRun {
  background-color: #fff;
}
.inputs-container {
  display: table;
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  .table-row .no-float {
    padding: 6px 18px;
  }
}
.striped .table-row {
  background: #f9f9f9;
}
</style>
